import CompaniesApi from '@/services/setup/CompaniesApiV2'

export interface CompanyInterface {
  id: string
  name: string
  address1: string
  address2: string
  postcode: string
  city: string
  state: string
  country: string
  country_code: string
  phone: string
  email: string
  legal_name: string
  tax_number: string
  fiscal_data: { country_code: string } | null
  arena_ids: bigint[]
  created_at: string
  updated_at: string
}

export class CompanyDTO implements CompanyInterface {
  id = ''
  name = ''
  address1 = ''
  address2 = ''
  postcode = ''
  city = ''
  state = ''
  country = ''
  country_code = ''
  phone = ''
  email = ''
  legal_name = ''
  tax_number = ''
  fiscal_data: { country_code: string } | null = null
  arena_ids = []
  created_at = ''
  updated_at = ''
}

export default class Company extends CompanyDTO {
  static api = CompaniesApi

  constructor(DTO: CompanyDTO) {
    super()
    Object.assign(this, DTO)
  }
}
